export const BENEFITS_SUCCESS = 'BENEFITS_SUCCESS';
export const BENEFITS_ERROR = 'BENEFITS_ERROR';
export const BENEFITS_LOADING = 'BENEFITS_LOADING';

export const EXCHANGES_SUCCESS = 'EXCHANGES_SUCCESS';
export const EXCHANGES_ERROR = 'EXCHANGES_ERROR';
export const EXCHANGES_LOADING = 'EXCHANGES_LOADING';

export const NEW_EXCHANGE_SUCCESS = 'NEW_EXCHANGE_SUCCESS';
export const NEW_EXCHANGE_ERROR = 'NEW_EXCHANGE_ERROR';
export const NEW_EXCHANGE_LOADING = 'NEW_EXCHANGE_LOADING';

export const CATEGORIES_SUCCESS = 'CATEGORIES_SUCCESS';
export const CATEGORIES_ERROR = 'CATEGORIES_ERROR';
export const CATEGORIES_LOADING = 'CATEGORIES_LOADING';

export const CURRENT_CATEGORY_SUCCESS = 'CURRENT_CATEGORY_SUCCESS';

export const CURRENT_PRODUCT_CATEGORY_SUCCESS =
  'CURRENT_PRODUCT_CATEGORY_SUCCESS';

export const POINTS_SUCCESS = 'POINTS_SUCCESS';
export const POINTS_ERROR = 'POINTS_ERROR';
export const POINTS_LOADING = 'POINTS_LOADING';

export const BALANCE_SUCCESS = 'BALANCE_SUCCESS';
export const BALANCE_ERROR = 'BALANCE_ERROR';
export const BALANCE_LOADING = 'BALANCE_LOADING';

export const PRODUCTS_BY_CATEGORY_SUCCESS = 'PRODUCTS_BY_CATEGORY_SUCCESS';
export const PRODUCTS_BY_CATEGORY_ERROR = 'PRODUCTS_BY_CATEGORY_ERROR';
export const PRODUCTS_BY_CATEGORY_LOADING = 'PRODUCTS_BY_CATEGORY_LOADING';

export const OPEN_PRODUCT_MODAL_SUCCESS = 'OPEN_PRODUCT_MODAL_SUCCESS';
